/* eslint-disable */
import Backbone from 'backbone';
import Promise from 'bluebird';
import _ from 'underscore';
import ko from 'knockout';
import React from 'react';
import ReactDOM from 'react-dom';
import pageContext from '@bingads-webui-static-legacy/page-context';
import summaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import ViewModel from '@bingads-webui-campaign-legacy/crud-campaign/viewmodel/create';
import tmpl from '@bingads-webui-campaign-legacy/crud-campaign/template/create.pug';
import Budget from '@bingads-webui-campaign-legacy/budget/view/budget';
import * as _LocationTargetsView from '@bingads-webui-campaign-legacy/location-targets/view/locationTargets';
import * as _CashbackSettings from '@bingads-webui-campaign/cashback-settings';
import * as personalizedOfferUtils from '@bingads-webui-campaign/personalized-offer-shared';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as _edm from '@bingads-webui-component-legacy/edm-campaign/index';
import * as scrollUtil from '@bingads-webui-component-legacy/extension/scrollTo';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import * as _Language from '@bingads-webui-component-legacy/language-selector/view/index';
import * as defaultLanguage from '@bingads-webui-component-legacy/language-selector/util/defaultLanguage';
import * as _AppEventDelegator from '@bingads-webui-component-legacy/app-event-delegator/index';
import * as _MultiLanguage from '@bingads-webui-campaign/multi-language-selector';
import * as _AdsCampaignDisclaimers from '@bingads-webui-campaign-react/ads-campaign-disclaimers';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import * as _SharedBudgetView from '@bingads-webui-campaign-legacy/shared-budget/view/shared-budget-switch-editor';
import * as _CopySettings from '@bingads-webui-campaign-legacy/crud-campaign/view/copy-campaign-settings';
import * as _BiddingStrategyView from '@bingads-webui-campaign-legacy/bidding-strategy/view/setting';
import * as campaignType from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import * as _ExperimentBudgetAlert from '@bingads-webui-campaign-legacy/experiments-tab/experiment-budget-alert-loader';
import * as schemas from '@bingads-webui-campaign/campaign-ui-schemas';
import * as _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import BiddingStrategyType from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';
import * as _DSASettingsView from '@bingads-webui-campaign-legacy/dsa-settings/view/dsa-settings';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import * as _AudienceCampaignShared from '@bingads-webui-campaign/audience-campaign-shared';
import * as _LoadMap from '@bingads-webui-campaign-legacy/dashboard-page/service/load-map';
import * as _physicalIntentOptions from '@bingads-webui-campaign-legacy/location-targets/viewmodel/physicalIntentOptions';
import * as _AudienceCampaignCrud from '@bingads-webui-campaign/crud-audience-campaign';
import * as SponsoredCampaignShared from '@bingads-webui-campaign/sponsored-campaign-shared';
import * as _BrandListsComponents from '@bingads-webui-campaign-react/brand-lists-components';
import * as _VanityUrlOption from '@bingads-webui-campaign-react/vanity-url-option';
import * as _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var newI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/campaign-creation-advanced');
var s$AdGroup = schemas.AdGroup;
var s$CampaignCriterion = schemas.CampaignCriterion;
var s$DisclaimerAdExtension = schemas.DisclaimerAdExtension;
var AppEventDelegator = _AppEventDelegator.default;
var edm = _edm.default;
var Language = _Language.default;
var LocationTargetsView = _LocationTargetsView.default;
var CopySettings = _CopySettings.default;
var BiddingStrategyView = _BiddingStrategyView.default;
var SharedBudgetView = _SharedBudgetView.default;
var MultiLanguage = _MultiLanguage.MultiLanguageSelector;
var AdsCampaignDisclaimers = _AdsCampaignDisclaimers.AdsCampaignDisclaimers;
var ExperimentBudgetAlert = _ExperimentBudgetAlert.ExperimentBudgetAlert;
var SharedRepository = _SharedRepository.default;
var DSASettingsView = _DSASettingsView.default;
var CashbackSettingsView = _CashbackSettings.CashbackSettings;
var loadMap = _LoadMap.loadMap;
var ImpressionTrackingView = _AudienceCampaignShared.ImpressionTrackingUrlOptions;
var {isSponsoredCampaignCashbackOptInAvailable} = SponsoredCampaignShared;
var BroadOnlySetting = _BrandListsComponents.WrappedBroadOnlySetting;
var defaultPopupIds = {
  'CampaignName': 'pop_BA_CampaignCreate_Settings_CampaignName',
  'Language': 'pop_BA_CampaignCreate_Settings_AdLanguage',
  'MultiLanguage': 'pop_BA_CampaignCreate_Settings_LanguageTargeting',
  TargetingSource: 'pop_BA_DSA_TargetingSource',
  Budget: 'pop_BA_CampaignCreate_Budget_SharedBudget'
};
var physicalIntentOptions = _physicalIntentOptions.default;
var VanityUrlOption = _VanityUrlOption.VanityUrlOption;
var preferencesService = _preferencesService.default || _preferencesService;
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      scenario: 'creation-workflow',
      showLanguage: true,
      Languages: [],
      showInitialUiBlocker: true,
      hideBidStrategy: false,
      deps: {},
      IsAdsGlobalizationPhase1Enabled: pageContext.Permissions.IsAdsGlobalizationPhase1Enabled,
      IsAdsGlobalizationPhase2Enabled: pageContext.Permissions.IsAdsGlobalizationPhase2Enabled,
      IsAdsGlobalizationPhase6Enabled: pageContext.Permissions.IsAdsGlobalizationPhase6Enabled,
      IsAdsGlobalizationPhase2JapanEnabled: pageContext.Permissions.IsAdsGlobalizationPhase2JapanEnabled,
      IsAdsGlobalizationPhase9Enabled: pageContext.Permissions.IsAdsGlobalizationPhase9Enabled,
      IsAdsGlobalizationPhase9VIEnabled: pageContext.Permissions.IsAdsGlobalizationPhase9VIEnabled
    });
    if (this.options && this.options.perfMarker) {
      this.showCampaignSettingMarker = this.options.perfMarker.createChild('Show_Campaign_Setting', {
        autoEnd: true
      });
      this.showCampaignSettingMarker.willInit();
    }
    if (this.options && this.options.activityLogger) {
      this.logActivity('display campaign settings step');
    }
    this.popupIds = _.defaults({}, this.options.popupIds, defaultPopupIds);
    this.shouldShowCashbackSettings = personalizedOfferUtils.isPersonalizedOfferAvailable(pageContext.Permissions, this.options.campaignType, this.options.campaignSubType);
    const shouldShowSponsoredCampaignCashbackOptIn = isSponsoredCampaignCashbackOptInAvailable(pageContext.Permissions, this.options.campaignType, this.options.campaignSubType, this.options.isMSStoreAdsGAWorkflow);
    this.isAudienceCampaign = this.options.campaignType === 'Audience';
    this.isAudienceVideoAdsCampaign = this.options.campaignSubType === 'AudienceVideoAds';
    this.isEnabledForVerifiedImpressionTracking = this.isAudienceCampaign && this.isAudienceVideoAdsCampaign && pageContext.Permissions.IsEnabledForVerifiedImpressionTrackingAtCampaignLevel;
    this.isSignUpPage = this.options.scenario === 'signup-creation-workflow';
    this.isWindowsStoreAdsEnabled = this.options.isMSStoreAdsGAWorkflow;
    this.isWindowsStoreAdsManualCPAEnabled = Boolean(_.result(pageContext.Permissions.dynamic, 'WindowsStoreAdsManualCPA', false));
    this.isSupportMaxConversionsForSscEnabled = Boolean(_.result(pageContext.Permissions.dynamic, 'SupportMaxConversionsForSsc', false));
    this.eventDelegator = _.result(this.options.deps, 'eventDelegator', new AppEventDelegator());
    this.ko_model = new ViewModel(_.extend({}, this.options, {
      isExperiment: this.isExperiment,
      isDisclaimerAdsEnabled: this.isDisclaimerAdsEnabled.bind(this),
      shouldShowCashbackSettings: this.shouldShowCashbackSettings,
      shouldShowSponsoredCampaignCashbackOptIn
    }));
    this.ko_model.isSponsoredCampaignCashbackOptedIn.subscribe(value => this.trigger('change:isSponsoredCampaignCashbackOptedIn', value));
    this.isVideo = this.options.CampaignSubType === 'AudienceVideoAds';
    this.autoTargetingSettings = _.find(this.options.CampaignSettings, setting => setting['@odata.type'] === '#Model.PredictiveTargetingSetting') || ({});
    if (this.options.scenario === 'campaign-settings') {
      if (_.contains(['search'], campaignType.default())) {
        this.biddingStrategyView = new BiddingStrategyView({
          entityType: 'Campaign',
          biddingStrategyType: this.options.BiddingScheme.Type,
          bidStrategyName: this.options.BidStrategyName,
          maxCpc: this.options.BiddingScheme.MaxCpc ? this.options.BiddingScheme.MaxCpc.Amount : null,
          targetCpa: this.options.BiddingScheme.TargetCpa,
          targetRoas: this.options.BiddingScheme.TargetRoas,
          targetAdPosition: this.options.BiddingScheme.TargetAdPosition,
          targetImpressionShare: this.options.BiddingScheme.TargetImpressionShare,
          campaignType: campaignType.default(),
          activityLogger: this.options.activityLogger,
          i18nNewDesign: this.options.deps.i18nNewDesign,
          shouldSupportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
          autoTargetingEnabled: this.autoTargetingSettings.PredictiveTargetingEnabled || false,
          ccJsData: this.options.ccJsData,
          isBroadMatchOnlyCampaign: this.ko_model.isBroadOnlySettingChecked()
        });
      } else if (_.contains(['shopping'], campaignType.default())) {
        this.biddingStrategyView = new BiddingStrategyView(_.extend({
          entityType: 'Campaign',
          biddingStrategyType: this.options.BiddingScheme.Type,
          bidStrategyName: this.options.BidStrategyName,
          maxCpc: this.options.BiddingScheme.MaxCpc ? this.options.BiddingScheme.MaxCpc.Amount : null,
          targetCpa: this.options.BiddingScheme.TargetCpa,
          targetRoas: this.options.BiddingScheme.TargetRoas,
          costPerSale: this.options.BiddingScheme.TargetCostPerSale,
          validateWithBudget: true,
          campaignType: 'shopping',
          isAfterSave: this.ko_model.isAfterSave(),
          activityLogger: this.options.activityLogger,
          i18nNewDesign: this.options.deps.i18nNewDesign,
          shouldSupportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
          shouldShowSponsoredCampaignCashback: shouldShowSponsoredCampaignCashbackOptIn,
          isSponsoredCampaignCashbackOptedIn: this.options.isSponsoredCampaignCashbackOptedIn,
          isMSStoreAdsGAWorkflow: this.options.isMSStoreAdsGAWorkflow,
          popupIds: {
            BidStrategy: this.popupIds.BidStrategy
          },
          ccJsData: this.options.ccJsData
        }, pageContext.Permissions.IsManualBiddingDeprecationEnabled ? {
          campaignSubType: this.options.CampaignSubType
        } : {}));
      } else if (_.contains(['audience'], campaignType.default())) {
        if (pageContext.Permissions.IsManualCpmEnabled || pageContext.Permissions.IsAudienceCampaignAutoBiddingV2Enabled) {
          this.biddingStrategyView = new BiddingStrategyView({
            entityType: 'Campaign',
            biddingStrategyType: this.options.BiddingScheme.Type,
            bidStrategyName: this.options.BidStrategyName,
            campaignSubType: this.options.CampaignSubType,
            campaignType: campaignType.default(),
            maxCpc: this.options.BiddingScheme.MaxCpc ? this.options.BiddingScheme.MaxCpc.Amount : null,
            targetCpa: this.options.BiddingScheme.TargetCpa,
            activityLogger: this.options.activityLogger,
            i18nNewDesign: this.options.deps.i18nNewDesign,
            shouldSupportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
            ccJsData: this.options.ccJsData
          });
        }
        if (this.isEnabledForVerifiedImpressionTracking) {
          var initialIASImpressionTrackingUrlValue = '';
          if (_.isArray(this.options.CampaignSettings) && this.options.CampaignSettings.length > 0 && _.isArray(this.options.CampaignSettings[0].VerifiedTrackingSettings) && this.options.CampaignSettings[0].VerifiedTrackingSettings.length > 0 && _.isArray(this.options.CampaignSettings[0].VerifiedTrackingSettings[0].VerifiedTrackingData) && this.options.CampaignSettings[0].VerifiedTrackingSettings[0].VerifiedTrackingData.length > 0) {
            initialIASImpressionTrackingUrlValue = this.options.CampaignSettings[0].VerifiedTrackingSettings[0].VerifiedTrackingData[0].Data.Values;
          }
          const showIASOption = false;
          if (showIASOption) {
            this.ImpressionTrackingView = new ImpressionTrackingView({
              i18n: i18n,
              isEnabledForVerifiedImpressionTrackingAtCampaignLevel: this.isEnabledForVerifiedImpressionTracking,
              initialIASImpressionTrackingUrlValue: initialIASImpressionTrackingUrlValue,
              isImpressionTrackingUrlSectionVisible: false
            });
          }
          var _this = this;
          this.ImpressionTrackingView && this.ImpressionTrackingView.on('IASInputChange', function (value) {
            if (value === null || _.isString(value) && value.length === 0) {
              _this.IASTrackingInfo = 'delete_value';
              return;
            }
            _this.IASTrackingInfo = value;
          });
        }
      }
    } else if (this.options.scenario === 'shopping-creation-workflow') {
      this.biddingStrategyView = new BiddingStrategyView(_.extend({
        entityType: 'Campaign',
        isInitialize: true,
        isCreation: true,
        isAfterSave: this.ko_model.isAfterSave(),
        campaignType: 'shopping',
        validateWithBudget: true,
        campaignSubType: this.options.campaignSubType,
        activityLogger: this.options.activityLogger,
        i18nNewDesign: this.options.deps.i18nNewDesign,
        shouldSupportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
        shouldShowSponsoredCampaignCashback: shouldShowSponsoredCampaignCashbackOptIn,
        isMSStoreAdsGAWorkflow: this.options.isMSStoreAdsGAWorkflow,
        popupIds: {
          BidStrategy: this.popupIds.BidStrategy
        },
        ccJsData: this.options.ccJsData
      }, this.options.hideBidStrategy ? {} : {
        biddingStrategyType: BiddingStrategyType.enhancedCPC
      }));
    } else if (this.options.scenario === 'smart-shopping-campaign-creation-workflow') {
      var BiddingScheme = this.options.BiddingScheme || ({});
      this.biddingStrategyView = new BiddingStrategyView({
        entityType: 'Campaign',
        maxCpc: BiddingScheme.MaxCpc ? BiddingScheme.MaxCpc.Amount : null,
        targetCpa: BiddingScheme.TargetCpa,
        targetRoas: BiddingScheme.TargetRoas,
        isInitialize: true,
        isCreation: true,
        campaignType: 'shopping',
        campaignSubType: 'ShoppingSmartAds',
        biddingStrategyType: this.isSupportMaxConversionsForSscEnabled ? BiddingScheme.Type : BiddingStrategyType.maxConversionValue,
        activityLogger: this.options.activityLogger,
        shouldSupportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
        isAfterSave: this.ko_model.isAfterSave(),
        ccJsData: this.options.ccJsData
      });
    }
    if (!this.isSignUpPage && this.options.scenario !== 'creation-workflow') {
      this.initBudgetView(this.options.Budget);
    }
    this.initDSASettingsView();
    this.initCashbackSettings();
    this.initRSASettingsView();
    this.initBroadOnlyView();
    if (this.isMultipleLanguageEnabledIncampaign()) {
      this.initMultiLangaugeSelector();
    } else {
      this.language = new Language(_.pick(this.options, 'i18nStrings', 'enableAdsGlobalizationPhase1'));
    }
    ko.computed(function () {
      if (!this.isMultipleLanguageEnabledIncampaign) {
        this.language.koModel.disabled(this.ko_model.isAfterSave());
      }
      if (this.dsaSettingsView) {
        this.dsaSettingsView.setValues({
          campaignId: this.ko_model.Id()
        });
      }
    }, this);
    if (this.isCreationScenario() && !this.isSignUpPage && this.options.scenario !== 'smart-shopping-campaign-creation-workflow') {
      this.copySettings = new CopySettings({
        scenario: this.options.scenario,
        activityLogger: this.options.activityLogger
      });
      this.copySettings.on('copy.campaign', this.copyFromCampaign.bind(this));
      this.copySettings.on('copy.errors', (function (errors) {
        ko.observableArray.fn.push.apply(this.ko_model.errors, errors);
      }).bind(this));
    }
    if (this.hasDisclaimer()) {
      this.disclaimerRepository = new SharedRepository({
        schema: s$DisclaimerAdExtension,
        skipExtensionCache: true
      });
      this.disclaimer = React.createRef();
      this.disclaimerProps = {
        ref: this.disclaimer,
        i18n: newI18n,
        campaignId: 0,
        DisclaimerAdsEnabled: true,
        AllowDisclaimerEnabled: true,
        schema: s$DisclaimerAdExtension,
        repository: this.disclaimerRepository,
        permissions: pageContext.Permissions,
        resetSelectedDisclaimer: (function () {
          delete this.disclaimerProps.selectedDisclaimer;
          this.renderDisclaimerUI();
        }).bind(this),
        usePanel: options && options.usePanel
      };
    }
    if (this.hasBroadOnlySetting()) {
      this.preferencesService = preferencesService;
      this.preferencesService.initialize();
    }
  },
  inCampaignEditing: function () {
    return this.options.Id > 0;
  },
  isExperiment: function () {
    return _.result(pageContext.CurrentCampaign, 'ExperimentId') > 0;
  },
  isMultipleLanguageEnabledIncampaign: function () {
    return this.options.showLanguage && !_.contains(['shopping'], campaignType.default());
  },
  hasDisclaimer: function () {
    const searchCondition = pageContext.Permissions.IsDisclaimerAdsEnabled && (this.options.scenario === 'creation-workflow' && this.options.campaignType === 'search' || this.options.scenario === 'campaign-settings' && campaignType.default() === 'search' && !this.isExperiment());
    const audienceCondition = pageContext.Permissions.IsDisclaimerAdsEnabled && pageContext.Permissions.IsMSANDisclaimerEnabled && (this.options.scenario === 'creation-workflow' && this.options.campaignType === 'Audience' && this.options.campaignSubType === 'AudienceStatic' || this.options.scenario === 'campaign-settings' && this.options.campaignType === 'Audience' && this.options.campaignSubType === 'AudienceStatic');
    return searchCondition || audienceCondition;
  },
  hasRsaAutoAssets: function () {
    return this.options.scenario === 'creation-workflow' && this.options.campaignType === 'search' || this.options.scenario === 'campaign-settings' && campaignType.default() === 'search';
  },
  hasBroadOnlySetting: function () {
    return Boolean(_.result(pageContext.Permissions.dynamic, 'BroadOnly', false)) && !Boolean(_.result(pageContext.Permissions.dynamic, 'PredictiveMatching', false)) && (this.options.scenario === 'creation-workflow' && this.options.campaignType === 'search' || this.options.scenario === 'campaign-settings' && campaignType.default() === 'search');
  },
  showVanityUrlSettings: function () {
    return pageContext.Permissions.IsVanityUrlEnabled && pageContext.Permissions.dynamic.VanityUrlWebsiteDescription && (this.options.scenario === 'creation-workflow' && this.options.campaignType === 'search');
  },
  getAssociatedDisclaimer: function (campaignId) {
    return campaignId ? this.disclaimerRepository.association.findAll({
      where: {
        campaignId: campaignId
      }
    }).then(function (disclaimerdata) {
      if (disclaimerdata && disclaimerdata.length > 0) {
        return disclaimerdata[0];
      } else {
        return null;
      }
    }) : Promise.resolve(null);
  },
  renderDisclaimerUI: function () {
    ReactDOM.render(React.createElement(AdsCampaignDisclaimers, this.disclaimerProps), this.$('.disclaimer__container')[0]);
  },
  toggleDisclaimerUI: function (disabled) {
    if (this.disclaimerProps != null) {
      this.disclaimerProps = _.extend({}, this.disclaimerProps, {
        DisclaimerAdsEnabled: disabled ? false : undefined,
        isDisclaimerCheckboxDisabled: disabled
      });
      this.renderDisclaimerUI();
    }
  },
  isDisclaimerAdsEnabled: function () {
    return _.isObject(this.options.context) && _.result(this.options.context.get('Draft.Disclaimer'), 'DisclaimerAdsEnabled', false) || _.result(_.find(this.options.CampaignSettings, function (setting) {
      return setting['@odata.type'] === '#Model.DisclaimerSetting';
    }), 'DisclaimerAdsEnabled', false);
  },
  initDisclaimerUI: function () {
    if (this.hasDisclaimer()) {
      this.disclaimerProps.campaignId = this.ko_model.Id() || 0;
      this.disclaimerProps.DisclaimerAdsEnabled = this.isDisclaimerAdsEnabled();
      this.disclaimerProps.isNativeAd = this.options.campaignType === 'Audience' && this.options.campaignSubType === 'AudienceStatic';
      this.disclaimerProps.onDisclaimerCheckboxChange = (function (disclaimerAdsEnabled) {
        this.disclaimerProps.DisclaimerAdsEnabled = disclaimerAdsEnabled;
        this.dsaSettingsView && this.dsaSettingsView.setValues({
          disclaimerAdsEnabled: disclaimerAdsEnabled
        });
        this.logActivity(`disclaimer changed: ${disclaimerAdsEnabled ? 'enabled' : 'disabled'}`);
      }).bind(this);
      this.getAssociatedDisclaimer(this.disclaimerProps.campaignId).then((function (data) {
        if (data) {
          this.disclaimerProps.selectedDisclaimer = data;
        }
        this.renderDisclaimerUI();
      }).bind(this));
    } else {
      this.$('.disclaimer__container').empty();
    }
  },
  initAutoAssetsUI: function () {
    if (this.hasRsaAutoAssets()) {
      this.ko_model.hasRsaAutoAssets(true);
      this.ko_model.isRsaAutoAssetsSettingChecked.subscribe((function (checked) {
        this.logActivity(`RSA auto assets setting changed: ${checked ? 'enabled' : 'disabled'}`);
      }).bind(this));
    }
  },
  initBroadOnlyUI: function () {
    if (this.hasBroadOnlySetting()) {
      this.ko_model.hasBroadOnlySetting(true);
      this.renderBroadOnlySetting();
      if (this.biddingStrategyView) {
        this.ko_model.isBroadOnlySettingChecked.subscribe((function (checked) {
          this.logActivity('broad only setting changed: ' + checked);
          this.biddingStrategyView.viewModel.isBroadMatchOnlyCampaign(checked);
        }).bind(this));
      }
    }
  },
  renderBroadOnlySetting: function () {
    ReactDOM.unmountComponentAtNode(this.$('.broad-only-setting').get(0));
    const props = {
      theme: this.ko_model.theme,
      i18n: this.options.deps.i18nNewDesign,
      serverContext: this.options.serverContext,
      scope: this.options.scope,
      permissions: pageContext.Permissions,
      preferenceService: this.preferencesService,
      campaignId: pageContext.CurrentCampaign && pageContext.CurrentCampaign.Id,
      isBroadMatchOnly: this.ko_model.isBroadOnlySettingChecked(),
      setIsBroadMatchOnly: value => this.ko_model.isBroadOnlySettingChecked(value),
      onBrandListsChange: (selectedBrandLists, [deletedBrandListIds, addedBrandListIds]) => {
        this.ko_model.selectedBrandLists(selectedBrandLists);
        this.ko_model.deletedBrandListIds(deletedBrandListIds);
        this.ko_model.addedBrandListIds(addedBrandListIds);
      },
      cid: pageContext.CurrentAccount.AdvertiserCustomerID,
      aid: pageContext.CurrentAccount.Id
    };
    ReactDOM.render(React.createElement(BroadOnlySetting, props, null), this.$('.broad-only-setting')[0]);
  },
  initVanityUrlSettings: function () {
    if (this.showVanityUrlSettings()) {
      this.ko_model.showVanityUrlSettings(true);
      this.renderVanityUrlSettings();
    }
  },
  renderVanityUrlSettings: function () {
    ReactDOM.unmountComponentAtNode(this.$('.vanity-url-option').get(0));
    const props = {
      i18n: this.options.deps.i18nNewDesign,
      vanityUrlSettings: this.ko_model.vanityUrlSettings(),
      onChange: settings => this.ko_model.vanityUrlSettings(settings)
    };
    ReactDOM.render(React.createElement(VanityUrlOption, props, null), this.$('.vanity-url-option').get(0));
  },
  setBidStrategyForPersonalizedOffersV2: function (enabled) {
    personalizedOfferUtils.setBidStrategyForPersonalizedOffers.bind(this)(enabled);
  },
  initCashbackSettings: function () {
    if (this.shouldShowCashbackSettings) {
      var cashBackSettings = _.result(this.options, 'CampaignCashback') || ({});
      this.cashbackSettingsView = new CashbackSettingsView({
        PersonalizedOffersEnabled: cashBackSettings.PersonalizedOffersEnabled,
        CashbackMonthlyBudget: cashBackSettings.MonthlyBudget,
        CashbackPercent: cashBackSettings.Percent,
        CashbackScope: cashBackSettings.Scope,
        CouponsEnabled: cashBackSettings.CouponsEnabled,
        isCashbackScopeReadonly: this.options.campaignType !== 'shopping',
        deps: {
          i18n: i18n,
          pageContext: pageContext,
          decimal: decimal
        },
        showCoupon: this.options.campaignType === 'shopping' && this.options.isNotAudienceCampaign,
        isCreationScenario: this.isCreationScenario(),
        isReadOnly: personalizedOfferUtils.shouldPersonalizedOffersReadOnly(this.ko_model.isAfterSave(), this.biddingStrategyView)
      });
      personalizedOfferUtils.setupCommonCashbackObserver(this);
      if (pageContext.Permissions.IsCostPerSaleEnabled && this.biddingStrategyView && this.options.campaignType === 'shopping') {
        this.ko_model.isAfterSave.subscribe(isAfterSave => {
          this.biddingStrategyView.viewModel.isAfterSave(isAfterSave);
          if (this.cashbackSettingsView) {
            this.cashbackSettingsView.viewModel.isReadOnly(personalizedOfferUtils.shouldPersonalizedOffersReadOnly(isAfterSave, this.biddingStrategyView));
          }
          if (this.cashbackSettingsView.viewModel.isEnablePersonalizedOffersChecked() && isAfterSave) {
            this.setBidStrategyForPersonalizedOffersV2(true);
          }
        });
      }
    }
  },
  setupBudgetValidationForCostPerSale: function () {
    if (this.budget && this.biddingStrategyView) {
      this.budget.viewModel.isCPSSelected(this.biddingStrategyView.viewModel.selectedBidStrategy() === BiddingStrategyType.costPerSale);
      this.budget.viewModel.sharedBudgetIsNotAllowedWarning(i18n.getString('CPS_NotAllowedSharedBudget') || 'Shared budget is not allowed if CPS is selected');
      this.biddingStrategyView.viewModel.selectedBidStrategy.subscribe(strategy => {
        this.budget.viewModel.isCPSSelected(strategy === BiddingStrategyType.costPerSale);
        this.budget.viewModel.sharedBudgetIsNotAllowedWarning(i18n.getString('CPS_NotAllowedSharedBudget') || 'Shared budget is not allowed if CPS is selected');
      });
      this.biddingStrategyView.viewModel.budgetAmount = this.budget.budgetView.ko_model.Amount();
      this.budget.budgetView.ko_model.Amount.subscribe(amount => {
        this.biddingStrategyView.viewModel.budgetAmount = amount;
      });
    }
  },
  validateMultipleLanguage: function () {
    var isValidate = true;
    if (this.inCampaignEditing()) {
      isValidate = _.isEmpty(this.options.Languages) || !_.isEmpty(this.language.getSelectedLanguages());
    } else {
      isValidate = !_.isEmpty(this.language.getSelectedLanguages());
    }
    this.updateLanguageErrorMessage(isValidate);
    return isValidate;
  },
  updateLanguageErrorMessage: function (isValidate) {
    if (isValidate) {
      this.ko_model.languageError('');
    } else {
      this.ko_model.languageError(i18n.getString('Campaign_Validation_LanguageSelectionRequired'));
    }
  },
  logActivity: function (message, api) {
    api = api || this.options.scenario;
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, api);
    }
  },
  initMultiLangaugeSelector: function () {
    var languageOptions = {
      languages: _.sortBy(_.without(s$AdGroup.properties.Language.enum, 'None')),
      inEditMode: true,
      selectedLanguages: [defaultLanguage.get()],
      i18n: i18n
    };
    languageOptions.languages = _.without(languageOptions.languages, 'Simplifiedchinese', 'Traditionalchinese');
    if (!pageContext.Permissions.IsSimplifiedChineseLanguageEnabledInMultipleLanguage) {
      languageOptions.languages = _.without(languageOptions.languages, 'SimplifiedChinese');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase1Enabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase2Enabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase6Enabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Hebrew', 'Arabic', 'Russian');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase2JapanEnabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Japanese');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase9Enabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
    }
    if (!pageContext.Permissions.IsAdsGlobalizationPhase9VIEnabled) {
      languageOptions.languages = _.without(languageOptions.languages, 'Vietnamese');
    }
    if (pageContext.Permissions.IsDomesticSimplifiedChineseEnabled) {
      languageOptions.languages = ['SimplifiedChinese'];
    }
    if (this.inCampaignEditing()) {
      languageOptions.selectedLanguages = this.options.Languages || [];
    }
    languageOptions.activityLogger = this.options.activityLogger;
    languageOptions.scenario = this.options.scenario;
    this.language = new MultiLanguage(languageOptions);
    this.language.on('selectedLanguages:changed', function () {
      this.validateMultipleLanguage();
    }, this);
  },
  instantiateLocationTargetsView: function () {
    const isWindowsStoreAd = this.options.campaignSubType == 'ShoppingSponsoredProductAd' && this.isWindowsStoreAdsEnabled;
    var options = {
      scenario: this.options.scenario,
      campaignId: Number(this.options.Id),
      hideAudience: this.ko_model.isAudienceCampaignCreate(),
      popupIds: this.popupIds,
      campaign: this.options,
      showInitialUiBlocker: this.options.showInitialUiBlocker,
      activityLogger: this.options.activityLogger,
      deps: {
        eventDelegator: this.eventDelegator
      },
      physicalIntent: isWindowsStoreAd ? physicalIntentOptions.PeopleIn : undefined,
      isForVNext: this.options.isForVNext,
      supportCashbackSettings: personalizedOfferUtils.shouldSupportCashbackSettings(this.options, pageContext.Permissions),
      showPhysicalIntentView: !isWindowsStoreAd
    };
    if (!this.isMultipleLanguageEnabledIncampaign()) {
      options.campaignLanguage = this.language.koModel.language();
    } else {
      options.languageSelector = this.language;
    }
    this.locationTargetsView = new LocationTargetsView(options);
  },
  willShow: function () {
    window.scrollTo(0, 0);
    var context = this.options.context.get('Campaign');
    if (!_.isEmpty(context)) {
      this.ko_model.Id(context.Id);
    }
    var budgetDraft = this.options.context.get('Draft.Budget');
    this.initBudgetView(_.isEmpty(budgetDraft) ? this.options.Budget : budgetDraft);
    if (this.budget) {
      this.$('.budget').empty().append(this.budget.render().$el);
      this.setupBudgetValidationForCostPerSale();
    }
    if (!_.isEmpty(budgetDraft)) {
      this.budget && this.budget.update(budgetDraft);
    }
    this.initDisclaimerUI();
    this.ko_model.hasChanges(false);
    var hasDSASettings = context && context.DomainName;
    if (hasDSASettings && this.dsaSettingsView) {
      this.ko_model.enableMixedModeDSASettings(false);
      this.ko_model.isMixedModeDSASettingsChecked(true);
      this.dsaSettingsView.setValues({
        disabled: true,
        DomainLanguage: _.result(context, 'Language'),
        DomainName: _.result(context, 'DomainName'),
        Source: _.result(context, 'Source'),
        campaignId: context.Id,
        targetingSourceCampaignId: context.Id,
        dynamicDescriptionEnabled: _.result(context, 'DynamicDescriptionEnabled', false)
      });
    }
  },
  isNotAudienceCampaign: function () {
    return _.contains(['campaign-settings', 'shopping-creation-workflow'], this.options.scenario) && campaignType.default() !== 'audience';
  },
  greyOutBudgetIfExperiment: function () {
    if (this.options.scenario !== 'campaign-settings') {
      return;
    }
    if (_.result(pageContext.CurrentCampaign, 'ExperimentId')) {
      this.$('.budget input').attr('disabled', true);
      this.experimentBudgetAlert = new ExperimentBudgetAlert({
        experimentId: pageContext.CurrentCampaign.ExperimentId
      });
      this.$('.budget-alert').html(this.experimentBudgetAlert.el);
    } else if (pageContext.Permissions.IsExperimentsEnabled && campaignType.default() === 'search') {
      jsdata.Experiment.findAll({
        query: {
          $select: 'Id',
          $filter: '(Status eq Enum.ExperimentStatus\'Active\' or Status eq Enum.ExperimentStatus\'Scheduled\')',
          $top: 1,
          $count: true
        }
      }, {
        entitySet: edm.currentCampaign.Experiments
      }).then((function (response) {
        if (response.totalCount) {
          this.experimentBudgetAlert = new ExperimentBudgetAlert({
            campaignId: pageContext.CurrentCampaign.Id
          });
          this.$('.budget-alert').html(this.experimentBudgetAlert.el);
        }
      }).bind(this));
    }
  },
  initDSASettingsView: function () {
    if (this.ko_model.isMixedDSACampaignCreate() || this.ko_model.isMixedDSACampaignRecommendation) {
      var dsaSettings = _.find(this.options.CampaignSettings, setting => setting['@odata.type'] === '#Model.DynamicSearchAdsSetting') || _.first(this.options.CampaignSettings);
      var hasDSASettings = dsaSettings ? !!dsaSettings.DomainName : false;
      var defaultDSADomainName = localStorage.get('DSACampaignDefaultWebsite') || '';
      this.dsaSettingsView = new DSASettingsView({
        DomainLanguage: _.result(dsaSettings, 'Language', 'English'),
        DomainName: _.result(dsaSettings, 'DomainName', defaultDSADomainName),
        Source: _.result(dsaSettings, 'Source', 'SystemIndex'),
        campaignId: this.ko_model.Id(),
        logActivity: this.logActivity.bind(this),
        popupIds: this.popupIds,
        disabled: !this.ko_model.isMixedDSACampaignRecommendation && hasDSASettings,
        isCampaignSettingsScenario: this.options.scenario === 'campaign-settings',
        dynamicDescriptionEnabled: hasDSASettings ? _.result(dsaSettings, 'DynamicDescriptionEnabled', false) : true,
        isMixedDSACampaignRecommendation: this.ko_model.isMixedDSACampaignRecommendation
      });
      this.ko_model.enableMixedModeDSASettings(!hasDSASettings);
      this.ko_model.isMixedModeDSASettingsChecked(hasDSASettings);
      this.ko_model.isMixedModeDSASettingsChecked.subscribe((function (checked) {
        this.logActivity(`DSA settings changed: ${checked ? 'enabled' : 'disabled'}`);
      }).bind(this));
    }
  },
  initRSASettingsView: function () {
    if (this.hasRsaAutoAssets()) {
      this.rsaSettings = _.find(this.options.CampaignSettings, setting => setting['@odata.type'] === '#Model.ResponsiveSearchAdsSetting');
      var isRsaAutoAssetsSettingChecked = this.rsaSettings ? !!this.rsaSettings.AutoGeneratedAssetsEnabled : false;
      this.ko_model.isRsaAutoAssetsSettingChecked(isRsaAutoAssetsSettingChecked);
    }
  },
  initBroadOnlyView: function () {
    if (this.hasBroadOnlySetting()) {
      const isBroadMatchOnlyCampaign = _.result(this.options, 'IsBroadMatchOnlyCampaign', false);
      this.isBroadMatchOnlyCampaign = isBroadMatchOnlyCampaign;
      this.ko_model.isBroadOnlySettingChecked(isBroadMatchOnlyCampaign);
      if (this.biddingStrategyView) {
        this.biddingStrategyView.viewModel.isBroadMatchOnlyCampaign(isBroadMatchOnlyCampaign);
      }
    }
  },
  render: function () {
    this.$el.html(tmpl({
      i18n: i18n,
      isSignUpPage: this.isSignUpPage,
      showLanguage: this.options.showLanguage,
      isOppotunityCampaignLevel: this.options.isOppotunityCampaignLevel,
      IsCampaignMultipleLanguageEnabled: this.isMultipleLanguageEnabledIncampaign(),
      isExperiment: this.isExperiment(),
      popupIds: this.popupIds,
      IsDomesticSimplifiedChineseEnabled: this.options.IsDomesticSimplifiedChineseEnabled
    }));
    ko.applyBindings(this.ko_model, this.el);
    if (this.budget) {
      this.$('.budget').empty().append(this.budget.render().$el);
      this.setupBudgetValidationForCostPerSale();
    }
    if (this.dsaSettingsView) {
      if (this.ko_model.isMixedDSACampaignCreate()) {
        this.$('.dsa-settings-container').empty().append(this.dsaSettingsView.render().$el);
      } else {
        this.$('.dsa-container').empty().append(this.dsaSettingsView.render().$el);
      }
    }
    if (this.cashbackSettingsView) {
      this.$('.cashback-settings-container').empty().append(this.cashbackSettingsView.render().$el);
    }
    if (this.ImpressionTrackingView) {
      this.$('.audienceSettings__container').empty().append(this.ImpressionTrackingView.render().$el);
    }
    this.greyOutBudgetIfExperiment();
    this.$('.language-setting').empty().html(this.language.render().el);
    if (this.biddingStrategyView && !this.options.hideBidStrategy) {
      this.$('.bidding-strategy__container').empty().html(this.biddingStrategyView.render().el);
    }
    if (this.options.scenario !== 'smart-shopping-campaign-creation-workflow') {
      this.locationTargetsPromise = jsdata.Intermediate.refresh('CampaignCriterion', []).then((function () {
        this.instantiateLocationTargetsView();
        if (!this.isNotAudienceCampaign()) {
          this.$('.location-targets').empty().append(this.locationTargetsView.render().$el);
        }
      }).bind(this));
    }
    if (this.copySettings) {
      this.$('.copy-campaign-settings').empty().append(this.copySettings.render().$el);
    }
    this.$('.campaign-settings__container')[0].addEventListener('change', (function () {
      this.ko_model.hasChanges(true);
    }).bind(this), false);
    jsdata.Intermediate.subscribe('CampaignCriterion', (function () {
      this.ko_model.hasChanges(true);
    }).bind(this));
    this.initDisclaimerUI();
    this.initAutoAssetsUI();
    this.initBroadOnlyUI();
    this.initVanityUrlSettings();
    this.trigger('didMount');
    return this;
  },
  hasChanges: function () {
    return this.ko_model.hasChanges();
  },
  copyFromCampaign: function (source) {
    if (!_.isArray(source)) {
      return;
    }
    const isWindowsStoreAd = this.options.campaignSubType == 'ShoppingSponsoredProductAd' && this.isWindowsStoreAdsEnabled;
    if (!_.isEmpty(source[0])) {
      var campaign = source[0];
      if ((campaign.Budget.Type === 'DailyStandard' || campaign.Budget.Type === 'DailyAccelerated' || campaign.Budget.Id > 0) && !(campaign.Budget.Id > 0 && isWindowsStoreAd)) {
        this.budget && this.budget.update(campaign.Budget);
      }
      this.BiddingScheme = campaign.BiddingScheme;
      this.trigger('copy.campaign', campaign);
      if (this.ko_model.isMixedDSACampaignCreate()) {
        var dsaSettings = _.find(campaign.CampaignSettings, setting => setting['@odata.type'] === '#Model.DynamicSearchAdsSetting');
        var domainName = _.result(dsaSettings, 'DomainName', null);
        var domainLanguage = _.result(dsaSettings, 'Language', null);
        var dsaSource = _.result(dsaSettings, 'Source', null);
        var dynamicDescriptionEnabled = _.result(dsaSettings, 'DynamicDescriptionEnabled', false);
        if (this.dsaSettingsView && (this.ko_model.isMixedDSACampaignCreate() && this.ko_model.enableMixedModeDSASettings())) {
          if (domainName) {
            this.ko_model.isMixedModeDSASettingsChecked(true);
            this.dsaSettingsView.setValues({
              DomainName: domainName,
              DomainLanguage: domainLanguage,
              Source: dsaSource,
              dynamicDescriptionEnabled,
              targetingSourceCampaignId: campaign.Id
            });
          } else {
            this.ko_model.isMixedModeDSASettingsChecked(false);
          }
        }
      }
      if (this.hasRsaAutoAssets()) {
        var rsaSettings = _.find(campaign.CampaignSettings, setting => setting['@odata.type'] === '#Model.ResponsiveSearchAdsSetting');
        var isRsaAutoAssetsSettingChecked = _.result(rsaSettings, 'AutoGeneratedAssetsEnabled', false);
        this.ko_model.isRsaAutoAssetsSettingChecked(isRsaAutoAssetsSettingChecked);
      }
      if (this.hasBroadOnlySetting()) {
        var isBroadMatchOnlyCampaign = _.result(campaign, 'IsBroadMatchOnlyCampaign', false);
        this.ko_model.isBroadOnlySettingChecked(isBroadMatchOnlyCampaign);
      }
      if (this.isMultipleLanguageEnabledIncampaign() && !_.isEmpty(campaign.Languages)) {
        this.language.koModel.selectedLanguages(campaign.Languages);
      }
      if (this.hasDisclaimer()) {
        this.disclaimerProps.DisclaimerAdsEnabled = _.result(_.find(campaign.CampaignSettings, function (setting) {
          return setting['@odata.type'] === '#Model.DisclaimerSetting';
        }), 'DisclaimerAdsEnabled', false);
      }
      if (this.cashbackSettingsView) {
        var CashbackPercent = _.chain(campaign).result('CampaignCashback').result('Percent').value();
        var CashbackScope = _.chain(campaign).result('CampaignCashback').result('Scope').value();
        var CashbackMonthlyBudget = _.chain(campaign).result('CampaignCashback').result('MonthlyBudget').value();
        var PersonalizedOffersEnabled = _.chain(campaign).result('CampaignCashback').result('PersonalizedOffersEnabled').value();
        var CouponsEnabled = _.chain(campaign).result('CampaignCashback').result('CouponsEnabled').value();
        this.cashbackSettingsView.setValues({
          PersonalizedOffersEnabled: PersonalizedOffersEnabled,
          CashbackPercent: CashbackPercent,
          CashbackScope: CashbackScope,
          CashbackMonthlyBudget: CashbackMonthlyBudget,
          CouponsEnabled: CouponsEnabled
        });
      }
      var isPromotionsForBrands = _.chain(campaign).result('CampaignCashback').result('IsPromotionsForBrands').value();
      this.ko_model.isSponsoredCampaignCashbackOptedIn(isPromotionsForBrands === true);
    }
    if (!_.isEmpty(source[1]) && _.isArray(source[1]) && !isWindowsStoreAd) {
      var criterions = source[1];
      criterions = _.map(criterions, function (criterion) {
        return _.omit(criterion, 'Id', 'Campaign');
      });
      this.locationTargetsView.setLocationData(criterions, 'campaign', true, true);
    }
    if (this.hasDisclaimer() && !_.isEmpty(source[2]) && _.isArray(source[2]) && source[2].length > 0) {
      this.disclaimerProps.selectedDisclaimer = source[2][0];
    }
    if (this.hasDisclaimer()) {
      this.renderDisclaimerUI();
    }
  },
  isCreationScenario: function () {
    return this.options.scenario === 'creation-workflow' || this.options.scenario === 'shopping-creation-workflow';
  },
  validateViewModel: function () {
    var isValid = this.ko_model.validate();
    if (!isValid) {
      _.each(this.ko_model.campaignProps, function (field) {
        if (!this.ko_model[field].isValid()) {
          this.logActivity('campaign field invalid: ' + field);
        }
      }, this);
    }
    return isValid;
  },
  isDSASettingsAvailable: function () {
    return this.dsaSettingsView && (this.ko_model.isMixedDSACampaignRecommendation || this.ko_model.isMixedDSACampaignCreate() && this.ko_model.isMixedModeDSASettingsChecked());
  },
  validate: function () {
    return _.reduce([this.validateViewModel(), this.isDSASettingsAvailable() ? this.dsaSettingsView.validate() : true, this.budget && !this.options.isOppotunityCampaignLevel ? this.budget.validate() : true, this.locationTargetsView && !this.options.isOppotunityCampaignLevel ? this.locationTargetsView.validate() : true, this.biddingStrategyView ? this.biddingStrategyView.validate() : true, this.isMultipleLanguageEnabledIncampaign() ? this.validateMultipleLanguage() : true, this.disclaimer ? this.disclaimer.current.validate() : true, this.cashbackSettingsView ? this.cashbackSettingsView.validate() : true, this.validateVerifiedImpressionTracking()], function (prev, next) {
      return prev && next;
    }, true);
  },
  shouldCancel: function () {
    return this.save();
  },
  shouldNext: function () {
    return this.save();
  },
  getPropertyValidationErrors: function () {
    var model = this.ko_model;
    var campaignProps = model.campaignProps;
    var propErrors = {};
    campaignProps.forEach(function (prop) {
      var errorsOfPropery = model[prop] && model[prop].errors ? model[prop].errors() : [];
      propErrors[prop] = errorsOfPropery;
    });
    if (this.budget && !this.budget.validate()) {
      propErrors = _.defaults({}, propErrors, {
        budget: ['Budget invalid']
      });
    }
    if (this.biddingStrategyView && !this.biddingStrategyView.validate()) {
      propErrors = _.defaults({}, propErrors, this.biddingStrategyView.getErrorMessages());
    }
    return propErrors;
  },
  getAllLocations: function () {
    if (!this.locationTargetsView) return null;
    var modelInfo = this.ko_model.toObject();
    var allLocationTargets = this.locationTargetsView.getValues({}, {
      keepAllLocations: true,
      populateParentField: true,
      removeNegativeId: true,
      campaignId: this.ko_model.Id() || modelInfo.Id,
      campaignName: modelInfo.Name
    });
    return allLocationTargets.locations.concat(allLocationTargets.intent || []);
  },
  getData: function () {
    if (this.ImpressionTrackingView) {
      this.ImpressionTrackingView.IASInputChange();
    }
    if (!this.validate()) {
      return false;
    }
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
    var params = this.ko_model.toObject();
    var dsaSettings = this.isDSASettingsAvailable() ? this.dsaSettingsView.getValues() : {};
    params = _.extend(params, dsaSettings);
    if (this.hasRsaAutoAssets()) {
      const originAutoGeneratedAsset = _.result(this.rsaSettings, 'AutoGeneratedAssetsEnabled', false);
      const isAutoGeneratedAssetsChanged = this.options.scenario === 'creation-workflow' || this.ko_model.isRsaAutoAssetsSettingChecked() !== originAutoGeneratedAsset && this.options.scenario === 'campaign-settings';
      var rsaAutoGeneratedAssetsSettings = isAutoGeneratedAssetsChanged ? {
        AutoGeneratedAssetsEnabled: this.ko_model.isRsaAutoAssetsSettingChecked()
      } : {};
      params = _.extend({}, params, rsaAutoGeneratedAssetsSettings);
    }
    if (this.hasBroadOnlySetting()) {
      const isBroadMatchOnlyCampaign = this.ko_model.isBroadOnlySettingChecked();
      const originBroadOnly = this.isBroadMatchOnlyCampaign;
      const isBroadMatchOnlyCampaignChanged = this.options.scenario === 'creation-workflow' || isBroadMatchOnlyCampaign !== originBroadOnly && this.options.scenario === 'campaign-settings';
      const broadOnlySetting = isBroadMatchOnlyCampaignChanged ? {
        IsBroadMatchOnlyCampaign: isBroadMatchOnlyCampaign
      } : {};
      if (isBroadMatchOnlyCampaign) {
        const associations = [], campaignId = pageContext.CurrentCampaign && pageContext.CurrentCampaign.Id, campaignName = params.Name;
        const savedBrandListIds = this.ko_model.savedBrandListIds();
        this.ko_model.addedBrandListIds().forEach(id => {
          if (!savedBrandListIds.filter(v => v.Status === 'Active').map(v => v.id).includes(id)) {
            associations.push({
              SharedEntityId: id,
              EntityId: campaignId,
              CampaignName: campaignName,
              Status: 'Active'
            });
          }
        });
        this.ko_model.deletedBrandListIds().forEach(id => {
          if (!savedBrandListIds.filter(v => v.Status === 'Deleted').map(v => v.id).includes(id)) {
            associations.push({
              SharedEntityId: id,
              EntityId: campaignId,
              CampaignName: campaignName,
              Status: 'Deleted'
            });
          }
        });
        broadOnlySetting.BrandListsAssociations = associations;
      }
      params = _.extend({}, params, broadOnlySetting);
    }
    if (this.budget) {
      params.Budget = this.budget.getValues(params);
    }
    if (this.ko_model.Id()) {
      params.Id = this.ko_model.Id();
    }
    if (this.options.scenario === 'campaign-settings' || this.options.scenario === 'smart-shopping-campaign-creation-workflow') {
      params = _.omit(params, 'TimeZone', 'Language');
      if (this.biddingStrategyView) {
        const biddingSchema = this.biddingStrategyView.getValues();
        params.BiddingScheme = biddingSchema;
        const autoTargetingDefault = this.autoTargetingSettings.PredictiveTargetingEnabled || false;
        if (pageContext.Permissions.dynamic.RSABidStrategyAutoTargeting && !pageContext.Permissions.dynamic.PredictiveMatching && campaignType.default() === 'search' && !!biddingSchema.AutoTargetingEnabled !== autoTargetingDefault) {
          params.AutoTargetingEnabled = biddingSchema.AutoTargetingEnabled || false;
        }
      }
    } else if (this.options.scenario === 'creation-workflow') {
      params.AdScheduleUseSearcherTimeZone = false;
    }
    if (this.isMultipleLanguageEnabledIncampaign()) {
      params.Languages = this.language.getSelectedLanguages();
    }
    if (this.targetingSource) {
      params.Source = this.ko_model.TargetingSourceSetting().Source;
    }
    if (this.locationTargetsView) {
      var targets = this.locationTargetsView.getValues({}, {
        populateParentField: true,
        removeNegativeId: true,
        campaignId: params.Id,
        campaignName: params.Name
      });
      params.CampaignCriterions = campaignType.default() !== 'audience' ? targets.deletedLocations.concat(targets.locations).concat(targets.intent) : targets.deletedLocations.concat(targets.locations);
      params.CampaignCriterions = _.map(params.CampaignCriterions, function (criterion) {
        return _.pick(criterion, _.keys(s$CampaignCriterion.properties));
      });
    }
    if (this.disclaimer) {
      var disclaimerSettings = this.disclaimer.current.getValues(params.Name);
      const disclaimerDefaultSettings = _.find(this.options.CampaignSettings, function (setting) {
        return setting['@odata.type'] === '#Model.DisclaimerSetting';
      });
      const createScenario = this.options.scenario === 'creation-workflow';
      if (createScenario) {
        _.defaults(params, disclaimerSettings);
        if (this.disclaimerProps.selectedDisclaimer) {
          params.DisclaimerAdsEnabled = !!this.disclaimerProps.DisclaimerAdsEnabled;
        }
      } else {
        const originalDisclaimerSetting = _.result(disclaimerDefaultSettings, 'DisclaimerAdsEnabled', false);
        const selectedDisclaimerId = _.result(this.disclaimer.current.state.selectedDisclaimer, 'Id', null);
        const originalDisclaimerId = _.result(this.disclaimerProps.selectedDisclaimer, 'Id', null);
        const isSelectedDisclaimerChanged = disclaimerSettings.DisclaimerAdsEnabled && selectedDisclaimerId && originalDisclaimerId !== selectedDisclaimerId;
        if (originalDisclaimerSetting !== disclaimerSettings.DisclaimerAdsEnabled || isSelectedDisclaimerChanged) {
          _.defaults(params, disclaimerSettings);
          params.DisclaimerAdsEnabled = !!this.disclaimerProps.DisclaimerAdsEnabled;
        }
      }
      if (disclaimerSettings.AdExtensionAssociations && disclaimerSettings.AdExtensionAssociations.length > 0) {
        this.ko_model.hasChanges(true);
      }
    }
    if (this.cashbackSettingsView) {
      params = _.extend(params, this.cashbackSettingsView.getValues());
      if ((pageContext.Permissions.IsPersonalizedOffersV2Enabled || pageContext.Permissions.IsPersonalizedOffersV3Enabled) && !this.biddingStrategyView && this.cashbackSettingsView.viewModel.isEnablePersonalizedOffersChecked()) {
        params.BiddingScheme = {
          Type: personalizedOfferUtils.getBidStrategyByCampaignTypeWhenPersonalizedOffersEnabled({
            campaignType: this.options.campaignType,
            i18n: i18n
          }).targetBidStrategy
        };
      }
    }
    if (this.ImpressionTrackingView) {
      params = _.extend(params, {
        VerifiedTrackingData: this.IASTrackingInfo
      });
    }
    if (this.showVanityUrlSettings()) {
      params = _.extend(params, this.ko_model.vanityUrlSettings());
    }
    return params;
  },
  getLocationRecommendationsStatus: function () {
    if (this.locationTargetsView) {
      return this.locationTargetsView.getLocationRecommendationsStatus();
    }
    return {};
  },
  handleCampaignResponse: function (data, hasLocationErrors, params) {
    this.ko_model.Id(data.Id);
    this.setContext(data.Id, params);
    var targetToCountMapping = {};
    _.each(data.CampaignCriterions, function (criterion) {
      if (criterion.CriterionType !== 'LocationIntentCriterion' && criterion.Id > 0) {
        var targetKey = (criterion.Status === 'Active' ? 'create' : 'delete') + criterion.SelectionStatus + criterion.CriterionType + 'Targets';
        var count = targetToCountMapping[targetKey];
        targetToCountMapping[targetKey] = (_.isUndefined(count) ? 0 : count) + 1;
      }
    });
    for (var target in targetToCountMapping) {
      var count = targetToCountMapping[target];
      if (count > 0) {
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, target, count);
      }
    }
    if (this.copySettings) {
      this.copySettings.hide();
    }
    if (this.locationTargetsView) {
      if (!hasLocationErrors) {
        this.locationTargetsView.clearAllErrors();
      }
      this.locationTargetsView.setCampaignId(data.Id);
      var updateLocation = this.locationTargetsView.refreshLocationData().then((function () {
        this.locationTargetsView.clearDeletedLocationsList();
        return true;
      }).bind(this));
    }
    var updateTargetingSource = this.saveTargetingSource(data.Id);
    return Promise.all([updateLocation, updateTargetingSource]).then((function () {
      if (this.saveCampaignMarker) {
        this.saveCampaignMarker.done();
      }
      return _.constant(true);
    }).bind(this));
  },
  errorElements: function () {
    return this.$('.campaign-settings__container .error, .campaign-settings__container .alert-danger').filter(':visible');
  },
  validationErrorNode: function () {
    return document.querySelector('.validation-error');
  },
  saveTargetingSource: function (id) {
    var retPromise = id && this.dsaSettingsView && this.dsaSettingsView.targetingSource ? this.dsaSettingsView.targetingSource.save(id) : Promise.resolve();
    return retPromise.then((function (result) {
      if (_.result(pageContext.CurrentCampaign, 'Id') === id) {
        var dsaSettings = _.find(pageContext.CurrentCampaign.CampaignSettings, setting => setting['@odata.type'] === '#Model.DynamicSearchAdsSetting');
        if (dsaSettings && this.targetingSource) {
          dsaSettings.Source = this.targetingSource.koModel.source();
        }
      }
      return result;
    }).bind(this));
  },
  validateVerifiedImpressionTracking: function () {
    if (this.isEnabledForVerifiedImpressionTracking) {
      if (this.IASTrackingInfo === 'error') {
        this.ImpressionTrackingView && this.ImpressionTrackingView.setErrors([i18n.getString('IASImpressionTracking_Invalid')], 'VerifiedImpressionTracking_IAS');
        return false;
      }
      return true;
    }
    return true;
  },
  setSavedBrandLists: function (brandListError = {}) {
    const savedBrandLists = [];
    const shouldFilterErrorCodes = ['CampaignServiceSharedEntityAssociationDoesNotExist', 'CampaignServiceSharedListIdInvalid', 'CampaignServiceFutureFeatureCode'];
    this.ko_model.addedBrandListIds().forEach(id => {
      if (!brandListError[id] || shouldFilterErrorCodes.includes(brandListError[id])) {
        savedBrandLists.push({
          id,
          Status: 'Active'
        });
      }
    });
    this.ko_model.deletedBrandListIds().forEach(id => {
      if (!brandListError[id] || shouldFilterErrorCodes.includes(brandListError[id])) {
        savedBrandLists.push({
          id,
          Status: 'Deleted'
        });
      }
    });
    this.ko_model.savedBrandListIds(savedBrandLists);
  },
  save: function () {
    var params = this.getData();
    if (!params) {
      scrollUtil.scrollAndCenter(this.errorElements());
      const node = this.validationErrorNode();
      if (node) {
        node.focus();
      }
      return false;
    }
    if (this.options && this.options.perfMarker) {
      this.saveCampaignMarker = this.options.perfMarker.createChild('Save_Campaign');
      this.saveCampaignMarker.willInit();
    }
    return jsdata.Campaign.create(params, {
      adapter: 'bulk',
      cacheResponse: false
    }).then((function (data) {
      if (_.isFinite(data.Id)) {
        var isCreate = this.isCreationScenario() && !this.ko_model.isAfterSave();
        var message = isCreate ? 'createCampaign' : 'updateCampaign';
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, isCreate ? 'createCampaign' : 'updateCampaign', '1');
        this.logActivity(message);
        personalizedOfferUtils.logCampaignPersonalizedOffers(this.shouldShowCashbackSettings, this.logActivity.bind(this), data, `${message}.`);
        summaryDataContextManager.getContext('/campaign/NewCampaign/Create?');
        this.eventDelegator && this.eventDelegator.trigger('campaignReload');
        this.setSavedBrandLists();
        return this.handleCampaignResponse(data, false, params);
      } else {
        this.handleApiErrors();
        scrollUtil.scrollAndCenter(this.errorElements());
        return false;
      }
    }).bind(this)).catch((function (response) {
      if (response && response.entity) {
        var errorsByEntity = {};
        var hasErrors = response && !_.isUndefined(response.errors);
        var hasLocationErrors = false;
        var hasEntityCreated = response && response.entity && !_.isUndefined(response.entity.Id);
        if (hasErrors) {
          errorsByEntity = this.separateErrors(response.errors);
          hasLocationErrors = errorsByEntity.location.length > 0;
        }
        if (hasEntityCreated) {
          this.handleCampaignResponse(response.entity, hasLocationErrors);
        }
        if (hasErrors) {
          if (errorsByEntity.campaign.length) {
            this.getAndHandleApiErrors(errorsByEntity.campaign);
          } else {
            this.locationTargetsView.handleApiErrors(errorsByEntity.location);
          }
          if (errorsByEntity.brandlist.length) {
            this.getAndHandleApiErrors(errorsByEntity.brandlist);
            const errMap = errorsByEntity.brandlist.reduce((acc, err) => {
              acc[err.Id] = acc[err.Error];
              return acc;
            }, {});
            this.setSavedBrandLists(errMap);
          }
        } else {
          this.handleApiErrors();
        }
      } else {
        this.ko_model.errors.add(response ? i18nErrors.getODataErrors(response.errors) : undefined);
      }
      this.scrollToErrors();
      return false;
    }).bind(this)).finally(withUiBlock());
  },
  setContext: function (campaignId, params) {
    var contextCampaign = this.ko_model.getValues();
    var dsaSettings = this.isDSASettingsAvailable() ? this.dsaSettingsView.getValues(true) : {};
    _.extend(contextCampaign, {
      Id: campaignId
    }, dsaSettings);
    if (_.isUndefined(contextCampaign.Language)) {
      if (!this.isMultipleLanguageEnabledIncampaign()) {
        _.extend(contextCampaign, {
          Language: this.language.koModel.language()
        });
      }
    }
    if (this.isMultipleLanguageEnabledIncampaign()) {
      _.extend(contextCampaign, {
        Languages: this.language.getSelectedLanguages()
      });
    }
    if (this.budget) {
      contextCampaign.Budget = this.budget.getValues(contextCampaign);
    }
    if (this.BiddingScheme) {
      contextCampaign.BiddingScheme = this.BiddingScheme;
    }
    if (_.isObject(this.options.context)) {
      var context = {
        Campaign: contextCampaign,
        CampaignParams: params
      };
      if (this.budget) {
        context['Draft.Budget'] = _.extend({}, contextCampaign.Budget);
      }
      if (this.disclaimer) {
        context['Draft.Disclaimer'] = _.pick(this.disclaimer.current.getValues(contextCampaign.Name), 'DisclaimerAdsEnabled');
      } else {
        delete context['Draft.Disclaimer'];
      }
      this.options.context.set(context);
    }
    if (this.cashbackSettingsView) {
      var cashbackSettings = this.cashbackSettingsView.getValues();
      contextCampaign['CampaignCashback'] = {
        Percent: cashbackSettings.CashbackPercent === -1 ? null : cashbackSettings.CashbackPercent,
        MonthlyBudget: cashbackSettings.CashbackMonthlyBudget,
        Scope: cashbackSettings.CashbackScope,
        PersonalizedOffersEnabled: cashbackSettings.PersonalizedOffersEnabled,
        CouponsEnabled: cashbackSettings.CouponsEnabled
      };
    }
  },
  separateErrors: function (errors) {
    const errMap = {
      campaign: [],
      location: [],
      brandlist: []
    };
    errors.forEach(err => {
      if (err.Type === 'Campaign Error') {
        errMap.campaign.push(err);
        return;
      }
      if (err.Type === 'Campaign Brand List Association Error') {
        errMap.brandlist.push(err);
        return;
      }
      errMap.location.push(err);
    });
    return errMap;
  },
  handleApiErrors: function (errors) {
    if (this.dsaSettingsView) {
      const domainNameError = _.filter(errors, function (err) {
        return err.property === 'DomainName';
      });
      errors = _.filter(errors, function (err) {
        return err.property !== 'DomainName';
      });
      this.dsaSettingsView.handleApiErrors(domainNameError);
    }
    this.ko_model.errors.add(errors);
    if (this.ko_model.isAfterSave()) {
      if (this.locationTargetsView) {
        this.locationTargetsView.setCampaignId(this.ko_model.Id());
        this.locationTargetsView.handleApiErrorsForCampaignLevel().then((function () {
          this.locationTargetsView.clearDeletedLocationsList();
        }).bind(this));
      }
    }
  },
  getBulkApiErrors: function (errors) {
    return i18nErrors.getBulkApiErrors(errors);
  },
  getAndHandleApiErrors: function (errors) {
    this.handleApiErrors(this.getBulkApiErrors(errors));
    _.chain(errors).map(function (error) {
      return error.Error;
    }).uniq().each(function (error) {
      this.logActivity(error, 'campaign creation api errors');
    }, this);
  },
  scrollToErrors: function () {
    scrollUtil.scrollAndCenter(this.errorElements());
  },
  clearApiErrors: function () {
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
  },
  remove: function () {
    if (this.locationTargetsView) {
      this.locationTargetsView.remove();
    }
    if (this.targetingSource) {
      this.targetingSource.remove();
    }
    if (this.experimentBudgetAlert) {
      this.experimentBudgetAlert.remove();
    }
    if (this.disclaimer) {
      ReactDOM.unmountComponentAtNode(this.$('.disclaimer__container').get(0));
      this.disclaimer = null;
    }
    if (this.showVanityUrlSettings()) {
      ReactDOM.unmountComponentAtNode(this.$('.vanity-url-option').get(0));
    }
    Backbone.View.prototype.remove.apply(this, arguments);
  },
  disableLanguage: function () {
    if (!this.isMultipleLanguageEnabledIncampaign()) {
      this.language.koModel.disabled(true);
    }
  },
  events: {
    'change input.name': 'campaignNameChange'
  },
  campaignNameChange: function () {
    this.logActivity('crud campaign campaign name change.');
  },
  initBudgetView: function (model) {
    var budgetFactory = SharedBudgetView.newFactory(Budget);
    var BCCBudgetImprovementEnabled = pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.BCCBudgetImprovementEnabled;
    var showBudgetMinRecommend = BCCBudgetImprovementEnabled && (this.options.scenario === 'campaign-settings' || this.options.scenario === 'smart-shopping-campaign-creation-workflow' && this.options.Budget);
    var minimumBudget = model && model.Amount ? model.Amount * 0.5 : undefined;
    var currencySymbol = this.options.deps && this.options.deps.i18nNewDesign ? this.options.deps.i18nNewDesign.getCurrencySymbol(pageContext.AccountCurrencyCode) : pageContext.AccountCurrencyCode;
    this.budget = budgetFactory({
      model: model,
      accountCurrencyCode: pageContext.AccountCurrencyCode,
      showBudgetMinRecommend,
      minimumBudget,
      currencySymbol,
      showInitialUiBlocker: this.options.showInitialUiBlocker,
      perfMarker: this.showCampaignSettingMarker,
      noApplyBudgetFromSharedLibrary: this.options.scenario === 'smart-shopping-campaign-creation-workflow' || this.options.campaignSubType == 'ShoppingSponsoredProductAd' && this.isWindowsStoreAdsEnabled,
      hideDailyBudgetOptions: this.options.campaignSubType == 'ShoppingSponsoredProductAd' && this.isWindowsStoreAdsEnabled && this.isWindowsStoreAdsManualCPAEnabled,
      activityLogger: this.options.activityLogger
    });
  },
  updateBidStrategy: function (isCoOpCampaign) {
    if (this.biddingStrategyView) {
      if (!isCoOpCampaign && this.cashbackSettingsView && this.cashbackSettingsView.viewModel.isEnablePersonalizedOffersChecked()) {
        this.setBidStrategyForPersonalizedOffersV2({
          enabled: true
        });
        return;
      }
      this.biddingStrategyView.updateBidStrategy(isCoOpCampaign);
    }
  }
});
export default View;

